import { z } from 'zod';

import { idSchema, isoDateSchema, jsonMetaSchema } from './common.schema';

export const notificationChannelSchema = z.enum(['push', 'browser', 'email_digest', 'vibrate']);
export const devicePlatformSchema = z.enum(['ios', 'android', 'web']);

export const notificationPreferencesSchema = z.object({
  id: idSchema,
  workspace_id: idSchema,
  user_id: idSchema,
  delivery_channels: z.array(notificationChannelSchema),
  events: z.record(z.boolean()),
  priority_filter: z.array(z.enum(['low', 'medium', 'high', 'urgent'])),
  do_not_disturb: jsonMetaSchema,
  sla_overrides_quiet: z.boolean(),
  push_grouping: z.enum(['per_ticket', 'each', 'latest']),
  created_at: isoDateSchema,
  updated_at: isoDateSchema,
});

export const updateNotificationPreferencesSchema = z
  .object({
    delivery_channels: z.array(notificationChannelSchema),
    events: z.record(z.boolean()),
    priority_filter: z.array(z.enum(['low', 'medium', 'high', 'urgent'])),
    do_not_disturb: jsonMetaSchema,
    sla_overrides_quiet: z.boolean(),
    push_grouping: z.enum(['per_ticket', 'each', 'latest']),
  })
  .partial();

export const registerDeviceTokenSchema = z.object({
  platform: devicePlatformSchema,
  token: z.string().min(1).max(2048),
  device_info: jsonMetaSchema.optional(),
});

export const unregisterDeviceTokenSchema = z.object({
  token: z.string().min(1).max(2048),
});
